import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import Loader from '../../../components/Loader/Loader'
import NotFound from '../../NotFound/NotFound'
import faqService, { FAQ_PENDING_PATH } from '../../../services/faq.service'
import FaqElasticSearchItem from './FaqItemDetails'

class FaqItemDirectLink extends Component {
  componentDidMount() {
    const { faqs, history, location } = this.props

    if (typeof window === 'undefined') return

    if (!Array.isArray(faqs) || faqs.length === 0) {
      sessionStorage.setItem(FAQ_PENDING_PATH, location.pathname)
      history.replace('/faq')
    }
  }

  render() {
    const { faqs, match } = this.props

    if (!Array.isArray(faqs) || faqs.length === 0) {
      return (
        <div className="container mt-5 mb-5">
          <Loader />
        </div>
      )
    }

    if (!faqService.findFaqById(faqs, match.params.faqId)) {
      return <NotFound />
    }

    return <FaqElasticSearchItem {...this.props} />
  }
}

const mapStateToProps = state => ({
  faqs: state.faqReducer.faq,
})

export default withRouter(connect(mapStateToProps)(FaqItemDirectLink))
